import { Component } from 'react'
import { OrderUserCounters, ProductionOrder } from 'stylewhere/api'
import {
  Box,
  EncodingProductionOrderDetail,
  EncodingUserCountersOrderRow,
  Icons,
  ParcelRowStatus,
  RowProps
} from 'stylewhere/components'
import styled from '@emotion/styled'

interface Props extends RowProps {
  order: OrderUserCounters
  index: number
  onClick: (index: number) => void
}

interface State {
  showDetail: boolean
}

export class EncodingUserCountersOrder extends Component<Props, State> {
  state: State = {
    showDetail: false
  }

  openDetail = (e: React.MouseEvent) => {
    // evita che il click sull'icona info propaghi anche il toggle di espansione della riga
    e.stopPropagation()
    this.setState({ showDetail: true })
  }

  closeDetail = () => {
    this.setState({ showDetail: false })
  }

  render() {
    const { order, index, onClick } = this.props
    const { showDetail } = this.state
    return (
      <Box flex pl={0} pr={0}>
        <SessionRow onClick={() => onClick(index)} vcenter>
          <Box row vcenter flex>
            <Session row flex vcenter>
              <Box width={30} vcenter>
                <ParcelRowStatus loading={false} expandable={!order.expanded} expanded={order.expanded} />
              </Box>
              <Box width={300}>{order.orderCode}</Box>
              <Box width={200} center>
                {order.encodings}
              </Box>
              <Box width={200} center>
                {order.totalEncodings + '/' + order.totalQuantity}
              </Box>
              <Box width={100} center onClick={this.openDetail} data-testid="order-detail-info-button">
                <Icons.Info width={22} height={22} />
              </Box>
            </Session>
          </Box>
          {order.expanded && <EncodingUserCountersOrderRow rows={order.rows} orderIndex={index} />}
        </SessionRow>
        {showDetail && (
          <EncodingProductionOrderDetail
            productionOrder={{ code: order.orderCode } as ProductionOrder}
            onClose={this.closeDetail}
          />
        )}
      </Box>
    )
  }
}

const SessionRow = styled(Box)`
  border-radius: 10px;
  border-bottom: 1px solid #f6f6f6;
  padding: 15px 0px;
  margin-bottom: 0px;
`

const Session = styled(Box)`
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #454545;
  margin-left: 7px;
`
